import { render, staticRenderFns } from "./PcContactUs.vue?vue&type=template&id=1951ec35&scoped=true&"
import script from "./PcContactUs.vue?vue&type=script&lang=js&"
export * from "./PcContactUs.vue?vue&type=script&lang=js&"
import style0 from "./PcContactUs.vue?vue&type=style&index=0&id=1951ec35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1951ec35",
  null
  
)

export default component.exports